<div class="tw-font-normal tw-text-gray-700 tw-text-md">{{ label }}</div>
<div class="tw-flex tw-items-start tw-gap-10" [formGroup]="form">
  @if (!!startIcon) {
    <span class="material-icons tw-absolute tw-ml-3 tw-mt-3">{{
      startIcon
    }}</span>
  }
  <textarea
    type="text"
    [readOnly]="disabled"
    [formControlName]="controlName"
    [style.resize]="'none'"
    [rows]="rows"
    class="{{ disabled ? 'tw-bg-zinc-100 focus:tw-outline-none' : '' }} py-2 {{
      startIcon ? 'tw-px-12' : 'tw-px-5'
    }} tw-border {{
      isError ? 'tw-border-red-500' : 'tw-border-zinc-400'
    }}  tw-rounded-md {{ width }} tw-text-md"
    [placeholder]="placeholder"
  ></textarea>
  @if (!!endIcon) {
    <span class="material-icons -tw-ml-20 tw-mt-3">{{ endIcon }}</span>
  }
</div>
<div
  class="tw-mt-2 tw-text-sm tw-flex tw-items-center tw-gap-1 {{
    isError ? 'tw-text-red-500' : ''
  }}"
>
  @if (isError) {
    <span class="material-icons tw-mr-1 tw-text-xl">error_outline</span>
  }
  {{ helperText }}
</div>
